import { isArray, pick } from 'lodash';
import { select } from 'redux-saga/effects';

import { ResourceLite } from '../resources/createResource';
import { EntityBase, EntityID } from '../resources/types';

import { PayloadApiRequest } from './sagaApi';
import sagaHandleApiResponse from './sagaHandleApiResponse';

interface Args<E extends EntityBase> {
  action: PayloadApiRequest<E>['action'];
  result: EntityID | EntityID[];
  data: any;
  payload: PayloadApiRequest<E> & { resource: ResourceLite<E> };
}

/**
 * Simulate API response using cached result
 */
export default function* sagaHandleCached<E extends EntityBase>({ action, result, data, payload }: Args<E>) {
  let obj;
  if (isArray(result)) {
    // @ts-ignore
    const entitiesObj = yield select(payload.resource.selectAll);
    obj = pick(entitiesObj, result);
  } else {
    obj = { [result]: data };
  }
  // @ts-ignore
  return yield sagaHandleApiResponse(
    {
      normalized: { entities: { [payload.resource.key]: obj }, result },
      data,
      config: payload,
      status: 299,
      statusText: '[cached]',
      headers: {},
    },
    {
      ...payload,
      action,
    },
  );
}
